import React from 'react';
import styled from 'styled-components';
import { useLinkComponent } from '../utils/component';

interface LinkedTagsProps {
  title: string;
  url: string;
}

export interface Props {
  categories: LinkedTagsProps[];
}

const LinkedCategoriesContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  gap: var(--spacer-s) var(--spacer-s);
  margin: var(--spacer) 0;
`;
const CategoryLinks = styled.div`
  display: flex;
`;

const CategoryLink = styled.div`
  border-radius: 6px;
  border: 1px solid var(--theme-palette-dark-white);
  background-color: var(--theme-palette-dark-white);
  color: var(--theme-palette-blue);
  padding: 4px 10px;
  font-weight: normal;
  font-size: 12px;
  text-align: center;

  &:hover {
    background-color: var(--theme-palette-red);
    color: var(--theme-palette-white);
    border: 1px solidvar(--theme-palette-red);
  }
`;

export const Tags = ({ categories }: Props) => {
  const LinkComponent = useLinkComponent();

  return (
    <LinkedCategoriesContainer>
      {categories.map((tags, index) => (
        <CategoryLinks key={index}>
          <LinkComponent href={tags.url} key={tags.title}>
            <CategoryLink>{tags.title}</CategoryLink>
          </LinkComponent>
        </CategoryLinks>
      ))}
    </LinkedCategoriesContainer>
  );
};
